import { createFileRoute, redirect } from '@tanstack/react-router'

import { MENU } from '@/constants/common/message.constants'
import { getDefaultUserMeTenant } from '@/features/auth/models'
import { USER_TYPE } from '@/libs/api/types'

export const Route = createFileRoute(
  '/_protected/$tenantKey/_performance_managements/monthly-customer-reports'
)({
  meta: () => [{ title: MENU.MONTHLY_CUSTOMER_REPORT }],
  beforeLoad: ({ context: { auth } }) => {
    if (auth.user.type !== USER_TYPE.OWNER) {
      throw redirect({
        to: `/${getDefaultUserMeTenant(auth.user).key}`
      })
    }
  }
})
